$(function () {
  'use strict';
  $("#tree-menu-trigger").fancytree();
  $("#tree-menu-reward").fancytree();
  var venueParams = {
    name: $('#venue-name').text().trim(),
    slug: $('#venue-slug').val(),
    location: $('#venue-location').text().trim(),
    lat: $('#venue-lat').text().trim(),
    lng: $('#venue-lng').text().trim(),
    phone: $('#venue-phone').text().trim(),
    venueId: $('#venue-id').text().trim()
  };
  $(".deals").on('click',function(e){
    //let termId = $(this).parent('div').children('input').attr('id');
    let termId =  $(this).data('value');
    getTriggerReward(termId,true);
  });
  const $menuTriggerTree = $('#tree-menu-trigger');
  const $menuRewardTree = $('#tree-menu-reward');
  const source = $('#tree-data').val() ? JSON.parse($('#tree-data').val() || []) : [];

  const venueId = venueParams.venueId;

  function renderCustomTree($treeMenu, checked=true){
    console.log("in trigger-rewards....renderCustomTree");
    $treeMenu.fancytree({
      clickFolderMode: 2,
      icon: false,
      source: source,
      extensions: ['table', 'glyph'],
      table: {
        checkboxColumnIdx: null,
        indentation: 12,
        nodeColumnIdx: 0
      },
      glyph: {
        preset: 'bootstrap3'
      },
      checkbox: checked ? true : function(event, data) {
        const node = data.node;

        if(node.type === 'item') {
          return true;
        }

        if(node.type === 'addon') {
          return node.data && node.data.rateable;
        }

        return false;
      },
      createNode: function (event, data) {
        const node = data.node;
        const $tdList = $(node.tr).find('>td');

        // format menus
        if (node.isFolder()) {
          $tdList.eq(0)
            .prop('colspan', 5)
            .nextAll().remove();
        }

        // format menu items
        if (node.type === 'item') {
          $tdList.eq(0)
            .prop('colspan', 2)
            .find('span.fancytree-title')
            .addClass('restaurant-menu-item')
            .next().remove();
        }

        // format menu item addons
        if (node.type === 'addon') {
          const firstCol = $tdList.eq(0);
          const title = firstCol.find('span.fancytree-title');
          // add title class to title
          title.addClass('restaurant-menu-item');
        }
      },
      click: function (event, data) {
        const node = data.node;
        const region = data.targetType;

        if (node.type === 'item' && region) {
          if (region !== 'expander') {
            node.toggleSelected();
            return false;
          }
        }

        if (node.type === 'addon' && region) {
          if (region !== 'expander') {
            node.toggleSelected();
            return false;
          }
        }
      }
    });
  }

/* quan, why call these on load
  renderCustomTree($menuTriggerTree);
  renderCustomTree($menuRewardTree);
*/
  const expands = {
    'tree-menu-trigger': true,
    'tree-menu-reward': true,
  }


  $('body').on('click', '.btn-expand-tree', function (event) {
    const tabletreeId = $(this).data('id');
    const expand = expands[tabletreeId] !== undefined ? expands[tabletreeId] : expands[tabletreeId] = true;
    toggleExpandTree(tabletreeId, expand);
    if (expand) {
      $(this).text('Expand all');
    } else {
      $(this).text('Close all');
    }
    expands[tabletreeId] = !expands[tabletreeId];
  });

  const toggleExpandTree = function (tabletreeId, expand) {
    $('#'+tabletreeId).fancytree('getTree').visit(function (node) {
      if(expand) {
        if(node.getLevel() < 3) {
          node.setExpanded(true);
        }else{
          node.setExpanded(false);
        }
      } else {
        node.setExpanded(false);
      }
      node.render();
    });
  }

  const $formreward = $('#form-reward');
  $('#btn-add-reward').on('click', function(){
    $('#btn-save-reward').text('Save');
    setTriggerRewards();
    $formreward.slideDown();
  })
  $('#btn-cancel-reward').on('click', function(){
    $('#btn-save-reward').text('Save');
    setTriggerRewards();
    $formreward.slideUp();
    scrollPosition('#triggeredRewards', true);
  })

  $('#enable-trigger').on('change', function(){
    console.log("=============",$menuTriggerTree)
    if($menuTriggerTree){
      const triggerTrees = $menuTriggerTree.fancytree('getTree');
      if($(this).is(':checked')) {
        $('#number-trigger').prop('disabled', false);
        if(triggerTrees && triggerTrees.options) triggerTrees.options['disabled'] = false;
        $menuTriggerTree.css("background", "white");
        $menuTriggerTree.find('a.btn-expand-tree').removeClass('disabled');
      }
      else {
        $('#number-trigger').prop('disabled', true);
        if(triggerTrees && triggerTrees.options) triggerTrees.options['disabled'] = true;
        $menuTriggerTree.css("background", "none");
        $menuTriggerTree.find('a.btn-expand-tree').addClass('disabled');
      }
    }
    
  })
  $('#enable-price-trigger').on('click', function(){
    if($(this).is(':checked')) $('#price-number-trigger').prop('disabled', false);
    else $('#price-number-trigger').prop('disabled', true);
  })
  $('#enable-reward').on('change', function(){
    const rewardTrees = $menuRewardTree.fancytree('getTree');
    if($(this).is(':checked')) {
      $('#number-reward').prop('disabled', false);
      if(rewardTrees && rewardTrees.options) rewardTrees.options['disabled'] = false;
      $menuRewardTree.css("background", "white");
      $menuRewardTree.find('a.btn-expand-tree').removeClass('disabled');
    } else {
      $('#number-reward').prop('disabled', true);
      if(rewardTrees && rewardTrees.options) rewardTrees.options['disabled'] = true;
      $menuRewardTree.css("background", "none");
      $menuRewardTree.find('a.btn-expand-tree').addClass('disabled');
    }
  })
  $('#enable-price-reward').on('click', function(){
    if($(this).is(':checked')) $('#price-number-reward').prop('disabled', false);
    else $('#price-number-reward').prop('disabled', true);
  })

  $('#triggeredRewards').on('click', '.label-text', function(){
    $(this).parent().find('input[type="checkbox"]').click();
  })

  $('#btn-save-reward').on('click', function(){
    const dataReward = {
      rewardId: $.trim($('#reward-id').val()),
      rewardName: $.trim($('#reward-name').val()),
      enableTrigger: $('#enable-trigger').prop('checked'),
      enablePriceTrigger: $('#enable-price-trigger').prop('checked'),
      enableReward: $('#enable-reward').prop('checked'),
      enablePriceReward: $('#enable-price-reward').prop('checked'),
    }

    if(dataReward.enableTrigger) {
      dataReward.numberTrigger = $.trim($('#number-trigger').val());
      dataReward.triggerMenu = selectedMenu($menuTriggerTree);
    };
    if(dataReward.enablePriceTrigger) dataReward.priceNumberTrigger = convertToNumber($.trim($('#price-number-trigger').val()));

    if(dataReward.enableReward) {
      dataReward.numberReward = $.trim($('#number-reward').val());
      dataReward.rewardMenu = selectedMenu($menuRewardTree);
    };
    if(dataReward.enablePriceReward) dataReward.priceNumberReward = convertToNumber($.trim($('#price-number-reward').val()));

    var arrVenueIds = [];
    $.each($("input[name='apply_terms']"), function(){
			arrVenueIds.push($(this).val());
		});

    //get termId if term selected
    var termId = $("#termId").val();
    if(termId && termId !=''){
      dataReward.termId = termId;
    }
    
    if(!validate(dataReward)) return ;
    else {
      $.ajax({
        url: '/restaurantadmin/saveTriggerReward',
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data:JSON.stringify({ venueId, arrVenueIds : arrVenueIds, data: dataReward }),
        success: function (result) {
          if (result.code == 0) {
            toastr.success(result.message);
            getTriggerReward(termId,false);
            $('#btn-cancel-reward').click();
          } else {
            toastr.error(result.message);
          }
        },
        error: function (err) { },
      });
    }
  })

  var  LIST_REWARDS = []

  function getTriggerReward(termId,status) {
    var arrVenueIds = [];
    $.each($("input[name='apply_terms']"), function(){
			arrVenueIds.push($(this).val());
		});
    if(arrVenueIds.length == 0){
      let venueIds = JSON.parse(localStorage.getItem('venueIds'));
      arrVenueIds = venueIds;
      localStorage.removeItem('venueIds');
    }
    let data;
    if(termId){
      data = JSON.stringify({ venueId : venueId, arrVenueIds : arrVenueIds, termId : termId });
    } else {
      data = JSON.stringify({ venueId : venueId, arrVenueIds : arrVenueIds });
    }
    $.ajax({
      url: '/restaurantadmin/getTriggerReward',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      data:data,
      success: function (result) {
        console.log("triggered rewards results++++++++",result);
        if (result.code == 0 && result.data) {
          dealTriggerReward(result.data,termId,status);
          LIST_REWARDS = result.data;
          if ($.fn.DataTable.isDataTable("#triggerRewardsTable")) {
            $("#triggerRewardsTable").dataTable().fnDestroy();
          }

          $("#triggerRewardsTable tbody").html("");
          var table = $('#triggerRewardsTable').DataTable({
              ordering: true,
              retrieve: true,
              responsive: true,
              data: LIST_REWARDS,
              columns: [
                  {
                    data: 'rewardName',
                  },
                  {
                    data: null, orderable: false,
                  },
              ],
              createdRow: function (row, data, index) {
                  let action = `<button class="btn btn=xs btn-primary btn-green btn-edit-reward" value="${data._id}">Edit</button>
                                <button class="btn btn=xs btn-danger btn-red btn-delete-reward" value="${data._id}">X</button>`
                  $('td', row).eq(-1).html(action).addClass('text-center').css('width', '100px');
              },
          });
        }
      },
      error: function (err) { }
    })
  }

  $.fn.getTriggerReward = getTriggerReward;
  getTriggerReward('',false);

  function validate(data){
    var isError = true;
    let duplicate = false;
    if(LIST_REWARDS.length){
      duplicate = LIST_REWARDS.filter((item) => {
        return String(item.rewardName).toLowerCase() == String(data.rewardName).toLowerCase() && String(item._id) != String(data.rewardId)
      }).length ? true : false;
    }

    if (data.rewardName == '') {
      scrollPosition('input#reward-name', isError);
      isError = false;
      $('input#reward-name').parent().addClass('has-error');
      $('input#reward-name').parent().find('span.help-block').html('This field is required');
    }else if (duplicate) {
      scrollPosition('input#reward-name', isError);
      isError = false;
      $('input#reward-name').parent().addClass('has-error');
      $('input#reward-name').parent().find('span.help-block').html('Reward name really existed!');
    } else if (data.rewardName.length > 255) {
      scrollPosition('input#reward-name', isError);
      isError = false;
      $('input#reward-name').parent().addClass('has-error');
      $('input#reward-name').parent().find('span.help-block').html('This field must have at most 255 charaters');
    }

    if(data.enableTrigger || data.enablePriceTrigger || data.enableReward || data.enablePriceReward ) {
      if(data.enableTrigger) {
        if(Number(data.numberTrigger) < 1) {
          scrollPosition('input#number-trigger', isError);
          isError = false;
          $('input#number-trigger').parent().addClass('has-error');
          $('input#number-trigger').parent().find('span.help-block').html('This field must be greater than 0');
        } /*else if(data.triggerMenu ) {
          scrollPosition('#error-menu-trigger', isError);
          isError = false;
          $('#error-menu-trigger').parent().addClass('has-error');
          $('#error-menu-trigger').parent().find('span.help-block').html('Your must select at least one menu');
        }*/
      }
      if(data.enablePriceTrigger && Number(data.priceNumberTrigger) < 1) {
        scrollPosition('input#price-number-trigger', isError);
        isError = false;
        $('input#price-number-trigger').parent().addClass('has-error');
        $('input#price-number-trigger').parent().find('span.help-block').html('This field must be greater than 0');
      }

      if(data.enableReward) {
        if(Number(data.numberReward) < 1) {
          scrollPosition('input#number-reward', isError);
          isError = false;
          $('input#number-reward').parent().addClass('has-error');
          $('input#number-reward').parent().find('span.help-block').html('This field must be greater than 0');
        } /*else if(data.rewardMenu ) {
          scrollPosition('#error-menu-reward', isError);
          isError = false;
          $('#error-menu-reward').parent().addClass('has-error');
          $('#error-menu-reward').parent().find('span.help-block').html('Your must select at least one menu');
        }*/
      }
      if(data.enablePriceReward && Number(data.priceNumberReward) <1) {
        scrollPosition('input#price-number-reward', isError);
        isError = false;
        $('input#price-number-reward').parent().addClass('has-error');
        $('input#price-number-reward').parent().find('span.help-block').html('This field is required to be greater than 0');
      }

    } else {
      isError = false;
      $('#error-trigger-reward').parent().addClass('has-error');
      $('#error-trigger-reward').parent().find('span.help-block').html("Your don't select any value");
    }
    return isError;
  }

  $('#triggeredRewards').on('change', function(){
    $(this).find('.has-error').removeClass('has-error');
    $(this).find('span.help-block').html("");
  })

  var scrollPosition = function(postion, scroll) {
    if (scroll && $(postion).length) $('html, body').animate({ scrollTop: $(postion).offset().top - 30 }, 'slow');
  }

  function dealTriggerReward(rewards,termId,status) {

    if($('#dealsTriggeredRewards').length || $('#triggerReward_'+termId).length) {
      $('#dealsTriggeredRewards').empty();
      if(rewards && rewards.length) {
        let strHtml = ''
        rewards.forEach(rewrd  => {
          let titleTrigger = '';
          let triggerMenu = '';
          let priceNumberTrigger = '';
          if(rewrd.enableTrigger && rewrd.triggerMenu && rewrd.triggerMenu.length) {
            triggerMenu = `Order any ${rewrd.numberTrigger || 0} `;
            rewrd.triggerMenu.forEach((rewrd, index) => {
              if(index > 0) triggerMenu = triggerMenu + ', ' + rewrd.title;
              else triggerMenu = triggerMenu + ' ' + rewrd.title;
            })
          }

          if(rewrd.priceNumberTrigger && rewrd.priceNumberTrigger) {
            if(triggerMenu) priceNumberTrigger = ` and $${rewrd.priceNumberTrigger}`
            else priceNumberTrigger = `Order $${rewrd.priceNumberTrigger}`
          }

          titleTrigger = triggerMenu + priceNumberTrigger;
          if(titleTrigger) titleTrigger = titleTrigger + ' of food'


          let titleReward = '';
          let rewardMenu = '';
          let priceNumberReward = '';

          if(rewrd.enableReward && rewrd.rewardMenu && rewrd.rewardMenu.length) {
            if(titleTrigger) rewardMenu = ` and get ${rewrd.numberReward}`;
            else if(titleTrigger) rewardMenu = ` and get ${rewrd.numberReward}`;
            else  rewardMenu = `Get ${rewrd.numberReward} `;
            rewrd.rewardMenu.forEach((reward, index)  => {
              if(index > 0) rewardMenu = rewardMenu + ', ' + reward.title;
              else rewardMenu = rewardMenu + ' ' + reward.title;
              // rewardMenu = rewardMenu + ', ' + reward.title;
            })
          }
          if(rewrd.priceNumberReward && rewrd.priceNumberReward) {
            if(rewardMenu) priceNumberReward = ` and a $${rewrd.priceNumberReward}`;
            else if(titleTrigger) rewardMenu = ` and get a $${rewrd.priceNumberReward}`;
            else priceNumberReward = `Get a $${rewrd.priceNumberReward}`;
          }

          titleReward =rewardMenu + priceNumberReward;
          if(titleReward) titleReward = titleReward + ' credit'

          strHtml = strHtml +
                    `
                    <div class="row accord-grey centerBlock" role="tab" id="headingDealsIndeal">
                      <h4 class="panel-title pl-1 pr-0 pl-md-4 pr-md-0">
                        <a id="dealsAccordionBtn" class="collapsed" data-toggle="collapse" data-parent="#collapseDealsInDeal" href="#collapseDealsInDeal" aria-expanded="true" aria-controls="collapseDealsInDeal">
                          <span class="plus_toggleable fa fa-plus"></span>
                          ${rewrd.rewardName}.
                           <span class=""></span>
                        </a>
                      </h4>
                      </div>
                    <div id="collapseDealsInDeal" class="panel-collapse collapse " role="tabpanel" aria-labelledby="headingDealsIndeal">
                    <div class="form-check">
                      <label style="width: 100%; padding-left:15px;" class="">
                        <span class="label-menu1">
                          <div class="form-group deals-triggered-rewards" style="margin-left: 40px">
                            <div>
                              ${rewrd.enableTrigger && rewrd.triggerMenu && rewrd.triggerMenu.length
                                ?
                                `<p>Order any 2 of these menu items:</p>
                                  <div class="col-xs-12">
                                    <table class='table table-tree' id="tree-trigger-${rewrd._id}">
                                      <thead>
                                      <tr>
                                          <th>
                                              <a href="javascript:void(0)" data-id="tree-trigger-${rewrd._id}" class="btn btn-default btn-expand-tree">Close all</a>
                                          </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      </tbody>
                                  </table>
                                </div>`
                                :''}
                                <p>And spend a minimum of $${rewrd.priceNumberTrigger || 0}</p>
                              </div>
                              <div>
                                ${rewrd.enableReward && rewrd.rewardMenu && rewrd.rewardMenu.length
                                  ?
                                  `<p>And Get a 1 of these menu items for free</p>
                                    <div class="col-xs-12">
                                      <table class='table table-tree' id="tree-reward-${rewrd._id}">
                                          <thead>
                                          <tr>
                                              <th>
                                                  <a href="javascript:void(0)" data-id="tree-reward-${rewrd._id}" class="btn btn-default btn-expand-tree">Close all</a>
                                              </th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          </tbody>
                                      </table>
                                    </div> `
                                  :''}
                                <p>And a $${rewrd.priceNumberReward || 0} credit to come back to the restaurant</p>
                              </div>
                          </div>
                        </span>
                      </label>
                    </div>
                    </div>`
        })
        if(status == false){
          $('#dealsTriggeredRewards').html(strHtml);
          dealMenuTriggeredRewards(rewards,null,false);
        } else {
          $('#triggerReward_'+termId).html(strHtml);
          dealMenuTriggeredRewards(rewards,termId,status);
        }
      }
    }
  }

  function dealMenuTriggeredRewards(rewards,termId,status) {
    if(rewards && rewards.length) {
      rewards.forEach(rewrd  => {
        if(status == false){
          let $dealTriggerTree = $('#dealsTriggeredRewards').find(`#tree-trigger-${rewrd._id}`);
          let $dealRewardTree = $('#dealsTriggeredRewards').find(`#tree-reward-${rewrd._id}`);
          if($dealTriggerTree.length) renderCustomTree($dealTriggerTree, false);
          if($dealRewardTree.length) renderCustomTree($dealRewardTree, false);
        } else {
          let $dealTriggerTree = $('#triggerReward_'+termId).find(`#tree-trigger-${rewrd._id}`);
          let $dealRewardTree = $('#triggerReward_'+termId).find(`#tree-reward-${rewrd._id}`);
            if($dealTriggerTree.length) renderCustomTree($dealTriggerTree, false);
            if($dealRewardTree.length) renderCustomTree($dealRewardTree, false);
        }
      })
    }
    if(status == true){
      $('#triggerReward_'+termId).on('click', 'span.label-menu1', function(e){
        if($(e.target).closest('.deals-triggered-rewards').length) e.preventDefault();
      });

      $('#triggerReward_'+termId).on('change', 'input[type="checkbox"]', function() {
        const tableId = $(this).data('id');
        const reward = LIST_REWARDS.filter(reward => String(reward._id) === String(tableId))
        if($(this).is(':checked') && reward.length) {
          let $dealTriggerTree = $('#triggerReward_'+termId).find(`#tree-trigger-${tableId}`);
          let $dealRewardTree = $('#triggerReward_'+termId).find(`#tree-reward-${tableId}`);
          if($dealTriggerTree.length) showMenu($dealTriggerTree, reward[0].triggerMenu || []);
          if($dealRewardTree.length) showMenu($dealRewardTree, reward[0].rewardMenu || []);
        }
      });
    }
  }
  $('#dealsTriggeredRewards').on('click', 'span.label-menu1', function(e){
    if($(e.target).closest('.deals-triggered-rewards').length) e.preventDefault();
  })

  $('#dealsTriggeredRewards').on('change', 'input[type="checkbox"]', function() {
    const tableId = $(this).data('id');
    const reward = LIST_REWARDS.filter(reward => String(reward._id) === String(tableId))
    if($(this).is(':checked') && reward.length) {
      let $dealTriggerTree = $('#dealsTriggeredRewards').find(`#tree-trigger-${tableId}`);
      let $dealRewardTree = $('#dealsTriggeredRewards').find(`#tree-reward-${tableId}`);
      if($dealTriggerTree.length) showMenu($dealTriggerTree, reward[0].triggerMenu || []);
      if($dealRewardTree.length) showMenu($dealRewardTree, reward[0].rewardMenu || []);
    }
  })

  function showMenu ($triggeredRewardsTree, menusDefault = []) {
    const showParent = function (node) {
      node.removeClass('hidden');
      node.setExpanded(true);
      if(node.getParent()) showParent(node.getParent())
    }
    const showChildren = function (nodes) {
      if(nodes.length) {
        nodes.forEach((node) => {
          node.removeClass('hidden');
          if(node.hasChildren()) {
            showChildren(node.children);
          }
        })
      }
    }

    var menusTree = $triggeredRewardsTree.fancytree('getTree');
    if(menusTree) {
      menusTree.visit(function(node) {
        node.addClass('hidden');
        node.setExpanded(false);
      });
      if(menusDefault.length) {
        menusDefault.forEach((item) => {
          var node = menusTree.getNodeByKey(item.key) || getNodeTree(menusTree, item.title);
          if(node) {
            if(node.getParent()) showParent(node.getParent());
            if(node.hasChildren()) showChildren(node.children);
            node.removeClass('hidden');
            node.setExpanded(false);
          }
        })
      }
    }
  }

  function getNodeTree (menusTree, title) {
    let item = null;
    menusTree.visit(function(node) {
      if(node.type == 'menu' && node.title == title) {
        return item = node;
      }
    })
    return item;
  }

  $('#triggerRewardsTable').on('click', '.btn-edit-reward', function(){
    const id = $(this).val();
    const reward = LIST_REWARDS.filter(reward => String(reward._id) === String(id))
    if(reward.length) {
      $('#btn-save-reward').text('Update');
      setTriggerRewards(reward[0], false);
      $formreward.slideDown();
    }
  })

  //Update/Edit Rewards for selected term getTriggerReward(termId);
  $('#terms_list').on('click','.termName',function(){
    var termId = $(this).attr('value');
    if(termId && termId !=''){
      getTriggerReward(termId,false);
    }
  });


  function selectedMenu ($menuTree) {
    const listMenu = [];
    try {
      const menuTree = $menuTree.fancytree('getTree');
      const menuSelected = menuTree.getSelectedNodes();
      if(menuSelected.length) {
        menuSelected.forEach(menu => {
          listMenu.push({
            key: menu.key,
            title: menu.title
          });
        });
      }
    } catch (error) {

    }
    return listMenu;
  }

  function setMenuTree ($menuTree, menusDefault = []) {
    try {
      const menuTree = $menuTree.fancytree('getTree');
      menuTree.visit(function(node) {
        node.setExpanded(false);
        node.setSelected(false);
      });
      if(menusDefault.length) {
        menusDefault.forEach((item) => {
          var node = menuTree.getNodeByKey(item.key) || getNodeTree(menusTree, item.title);
          if(node) {
            if(node.getParent()) expandedParent(node.getParent());
            node.setSelected(true);
          }
        })
      }
    } catch (error) {

    }
  }

  function expandedParent(node) {
    node.setExpanded(true);
    if(node.getParent()) expandedParent(node.getParent())
  }

  function setTriggerRewards(data = {}, def = true) {
    $('#reward-id').val(def ? '' : data._id || '');
    $('#reward-name').val(def ? '' : data.rewardName || '');
    $('#enable-trigger').prop('checked', def ? false : data.enableTrigger || false).change();
    $('#number-trigger').prop('disabled', def ? true : !data.enableTrigger).val(def ? '' : data.numberTrigger || '');
    $('#enable-price-trigger').prop('checked', def ? false : data.enablePriceTrigger || false);
    $('#price-number-trigger').prop('disabled', def ? true : !data.enablePriceTrigger).val(def ? '' : data.priceNumberTrigger || '').blur();
    $('#enable-reward').prop('checked', def ? false : data.enableReward || false).change();
    $('#number-reward').prop('disabled', def ? true : !data.enableReward).val(def ? '' : data.numberReward || '');
    $('#enable-price-reward').prop('checked', def ? false : data.enablePriceReward || false);
    $('#price-number-reward').prop('disabled', def ? true : !data.enablePriceReward).val(def ? '' : data.priceNumberReward || '').blur();
    setMenuTree($menuTriggerTree, def ? [] : data.triggerMenu || []);
    setMenuTree($menuRewardTree, def ? [] : data.rewardMenu || []);
    $('#triggeredRewards').find('.has-error').removeClass('has-error');
    $('#triggeredRewards').find('span.help-block').html("");
  }

  $('#triggerRewardsTable').on('click', '.btn-delete-reward', function(){
     var arrVenueIds = [];
    $.each($("input[name='apply_terms']"), function(){
			arrVenueIds.push($(this).val());
		});
    if(arrVenueIds.length == 0){
      let venueIds = JSON.parse(localStorage.getItem('venueIds'));
      arrVenueIds = venueIds;
      localStorage.removeItem('venueIds');
    }
    const rewardsId = $(this).val();
     var termId = $("#termId").val();
    if(rewardsId) {
      Swal.fire({
        title: "Are you sure to delete this triggered rewards?",
        text: "You will not be able to recover this triggered rewards!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#8B0000",
    }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
              url: '/restaurantadmin/deleteTriggerReward/'+rewardsId,
              method: 'DELETE',
              contentType: "application/json; charset=utf-8",
              data:JSON.stringify({ venueId : venueId, arrVenueIds : arrVenueIds, termId : termId }),
              error: function () {
                Swal.fire("Error!", 'Oops, something went wrong!', "error");
              }
          }).then(function (res) {
            $('#btn-cancel-reward').click();
            if(res.code == 0) {
              const message = res.message || "Successfully deleted!";
              Swal.fire({ title: "Deleted!", text: message, type: "success", showCancelButton: false, });
              getTriggerReward(termId,false);
            } else {
              const message = res.message || "Delete failed!";
              Swal.fire("Error!", message, "error");
            }
          })
        }
      });
    }
  })
  function convertToNumber(numberString) {
    numberString = numberString.replace(/\,/g, '');
    numberString = numberString.replace('$', '');
    numberString = numberString.replace(' %', '');
    const [integer, decimalpoint] = numberString.split('.');
    return integer;
  };
})
